// src/http/http.js
import axios from 'axios';
import {baseUrl} from "@/utils/base";

// 1. 创建 axios 实例（统一配置基础地址、超时）
const service = axios.create({
    baseURL: baseUrl, // 从环境变量取基础地址（推荐）
    // 也可以直接写死：baseURL: 'http://你的接口域名',
    timeout: 30000 // 请求超时时间
});

// 2. 请求拦截器（添加 token、处理请求前逻辑）
service.interceptors.request.use(
    (config) => {
        // 给所有请求添加 token 认证（关键！）
        const token =   window.sessionStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] =  token;
        }
        return config;
    },
    (error) => {
        // 请求错误的统一处理
        console.error('请求拦截器错误：', error);
        return Promise.reject(error);
    }
);

// 3. 响应拦截器（统一处理返回数据、错误）
service.interceptors.response.use(
    (response) => {
        // 只返回核心数据层，简化调用
        return response.data;
    },
    (error) => {
        // 统一错误提示（比如网络错误、401/403/500 等）
        let errMsg = '请求失败';
        if (error.response) {
            // 有响应码的错误（如 401 未登录、404 接口不存在）
            const status = error.response.status;
            switch (status) {
                case 401:
                    errMsg = '登录失效，请重新登录';
                    // 可在此处跳转到登录页
                    // router.push('/login');
                    break;
                case 403:
                    errMsg = '没有权限访问该接口';
                    break;
                case 500:
                    errMsg = '服务器内部错误';
                    break;
                default:
                    errMsg = error.response.data?.msg || errMsg;
            }
        } else if (error.request) {
            // 无响应的错误（如网络断开）
            errMsg = '网络异常，请检查网络';
        }
        console.error(errMsg, error);
        // 抛出错误，方便业务层捕获
        return Promise.reject(new Error(errMsg));
    }
);

// 4. 封装 GET 请求函数（优化版）
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        service // 使用封装后的 axios 实例
            .get(url, { params }) // 简写：params: params → params
            .then((data) => {
                resolve(data); // 这里的 data 已经是响应的 data 层
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// 可选：封装 POST 请求（方便后续使用）
export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        service
            .post(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// 5. 导出 axios 实例（备用）
export default service;
